import { type PaletteMode } from '@mui/material';
import { BRAND } from './paletteDark';

// The pilot ships the dark treatment the mockups specify. This palette exists
// so the light variant has somewhere to live when it is designed; it is not
// wired to a toggle yet.
const lightPalette = {
  mode: 'light' as PaletteMode,
  common: { black: BRAND.mocha, white: BRAND.parchment },
  primary: { main: BRAND.mocha, contrastText: BRAND.parchment },
  secondary: { main: BRAND.dustyOlive, contrastText: BRAND.parchment },
  text: {
    primary: BRAND.mocha,
    secondary: 'rgba(54, 47, 42, 0.66)',
    disabled: 'rgba(54, 47, 42, 0.38)',
  },
  background: {
    default: BRAND.parchment,
    paper: BRAND.parchment,
    neutral: '#eae3d9',
  },
  divider: 'rgba(54, 47, 42, 0.16)',
};

export default lightPalette;
